<script setup lang="ts">
import createJobStatusFilterItems from "@/types/requests/createJobStatusFilterItems"
import createJobStatusSetting from "@/types/requests/createJobStatusSetting"
import DropDownButton from  "@/components/Common/DropDownButton.vue"
import FileUploadModal from "@/components/Files/UploadModal.vue"
import { useAuth } from "@/services/user/Auth0UserProvider"
import Api from "@/services/api/ApiServiceFabrick";
import { ref, Ref, computed } from 'vue'
import i18n from '@/lang/i18n'

type ItemsType = {
  csvImport: string,
  csvExport: string,
}

type authoritiesType = {
  csvImport: boolean
  csvExport: boolean
}

const props = withDefaults(
  defineProps<{
    title: string
    items: ItemsType
    importTitle: string
    exportType: string
    importType: string
    operationOfficeId?: number
    settings?: createJobStatusSetting
    filterItems?: createJobStatusFilterItems
    trips?: string[]
    getList: () => void
    authorities: authoritiesType
    elementId: string
    addRequestParams?: (params: any) => any;
    btnClass: string
    dropDownStyle: string
    isDisabled: boolean
  }>(),
  {
    items: () => {
      return {
        csvImport: i18n.global.t("pages.common.button.csvUpsertImport"),
        csvExport: i18n.global.t("pages.common.button.csvUpsertExport")
      }
    },
    btnClass: "exec-btn mt-0 ml-1",
    dropDownStyle: "",
    isDisabled: false
  }
);

const { loginWithRedirect } = useAuth();
const exportModalstate: Ref<boolean> = ref(false)
const importModalstate: Ref<boolean> = ref(false)
const downloading: Ref<boolean> = ref(false)

const dropDownItems = computed(() => {
  const filteredItems = {} as ItemsType
  if (props.authorities.csvImport) {
    filteredItems.csvImport = props.items.csvImport
  }
  if (props.authorities.csvExport) {
    filteredItems.csvExport = props.items.csvExport
  }
  return filteredItems
})

function selectCsvItem(key: string) {
  exportModalstate.value = false;
  importModalstate.value = false;
  if (key.indexOf('Export') == -1) return importModalstate.value = true;
  return downloadFile()
}

function downloadFile() {
  downloading.value = true;

  let params = {
    operation_office_id: props.operationOfficeId ?? null,
    type: props.exportType,
    settings: props.settings ?? null,
    filter_items: props.filterItems ?? null,
    trips: props.trips ?? [],
  }
  if (props.addRequestParams) params = props.addRequestParams(params)

  Api().createJobStatus(params).then((data) => {
    pollingJobStatus(data.id)
  }).catch((error) => {
    const res = error.response
    switch (res.status) {
      case 401:
        loginWithRedirect({ appState: { targetUrl: location.pathname } })
        break
      case 403:
        location.reload()
        break
      case 422:
    }
    downloading.value = false
  })
}

function pollingJobStatus(id: number) {
  const interval = setInterval(() => {
    Api().getJobStatus(id).then((res) => {
      if (res.status == "completed") {
        download(res.file_path)
        clearInterval(interval)
      }
      if (res.status == "failed") {
        alert(res?.output_contents?.message)
        clearInterval(interval)
        downloading.value = false
      }
    })
  }, 3000)
}

function download(path: string) {
  if (!path) return;

  Api().fileDownload(path)
  downloading.value = false
}

function inactivateModalState(isReacquire: boolean) {
  importModalstate.value = false;
  if (isReacquire) props.getList()
}
</script>
<template>
  <DropDownButton
    :btnClass="props.btnClass"
    :dropDownStyle="props.dropDownStyle"
    :title="props.title"
    :items="dropDownItems"
    :isLoading="downloading"
    :elementId="props.elementId"
    :isDisabled="props.isDisabled"
    @selectDropDownItem="selectCsvItem"
  />

  <FileUploadModal
    :modalState="importModalstate"
    :title='props.importTitle'
    uploadBtnClass='exec-btn mt-0 ml-1'
    closeBtnClass='mt-0'
    :type="props.importType"
    :notes="$t('pages.common.messages.csvUpsertModalMessage')"
    @closeModal="inactivateModalState"
  />
</template>
